/*eslint-disable*/ export const messages = JSON.parse("{\"page-indicator.aria.label\":[\"Dot \",[\"selectedPage\"],\" is highlighted in a row of \",[\"pageCount\"],\" dots\"]}");
//# sourceMappingURL=messages.mjs.map